module.exports = __webpack_public_path__ + "img/ring_r_skip_1_null.2b1f51cd.png";